import jQuery from 'jquery'
import { store } from '@core/Store'
import { closeModal, openModal } from '@core/Components/Modal'
import { NoticeBox } from '@core/Components/NoticeBox'
import { showLogin } from '@core/Areas/Login/helpers'

export const ERROR_CODE_NOT_FOUND = 404

function showPopup(popupDiv: JQuery) {
  //delay 50 milliseconds to allow background layout completed
  setTimeout(function () {
    jQuery('div .popup').hide() // hide all other popups (especially any confirmation popup)
    const documentHeight = jQuery(document).height()
    popupDiv.css({ height: documentHeight }).fadeIn('fast')
    popupDiv.children('.overlay').animate({ opacity: 0.6 }, 'fast')

    const scrollTop = window.pageYOffset
      ? window.pageYOffset
      : document.body.parentElement
        ? document.body.parentElement.scrollTop
        : 0

    //Using a minimum scroll top to stop the close popup being over the 'log out' button.
    popupDiv.children('.window').css({ top: Math.max(scrollTop + 20, 40) })

    //Check if the height has changed due to showing the popup, and increase the overlay size accordingly
    const newHeight = popupDiv.children('.window').height() + scrollTop + 100
    if (newHeight > documentHeight) {
      popupDiv.children('.overlay').css({ height: newHeight })
    }
  }, 50)
}

function hideErrorPopup() {
  jQuery('#error-window').fadeOut('fast')
}

export function showErrorMessage(title: string, subtitle: string, callback?: () => void): void {
  showWarningOrErrorPopup({ title, subtitle, type: 'error', callback })
}

export function showWarningMessage(title: string, subtitle: string, callback?: () => void): void {
  showWarningOrErrorPopup({ title, subtitle, type: 'warning', callback })
}

export function handleErrorAsIs(statusCode: number, errorResponse: string): void {
  switch (statusCode) {
    case 403:
      showLogin()
      break
    case 550:
      jQuery('#error-window').html(errorResponse)
      showPopup(jQuery('#error-window'))
      jQuery('#error-window .close').click(() => {
        hideErrorPopup()
      })
      break
    case 551:
      location.reload()
      break
    default:
      jQuery('#ajax-error').show()
      break
  }
}

function showWarningOrErrorPopup({
  title,
  subtitle,
  type,
  callback,
}: {
  title: string
  type: 'error' | 'warning'
  callback?: () => void
  subtitle?: string
}) {
  store.dispatch(
    openModal({
      id: 'betting-v2-error-handler',
      modalComponent: NoticeBox,
      modalComponentProps: {
        title,
        subtitle,
        noticeBoxType: type === 'error' ? 'Error' : 'Warning',
        hasBorder: false,
        buttonClick: () => {
          store.dispatch(closeModal({ id: 'betting-v2-error-handler' }))
          callback?.()
        },
      },
      isDismissable: false,
      position: 'middle',
    })
  )
}
